module.exports = __webpack_public_path__ + "static/img/part_2_blue.a63468bf.png";